import React from 'react';
import css from './FeaturedBrandCard.module.css';
import { NamedLink } from '../../../components';

function FeaturedBrandCard(props) {
  const { brand } = props;
  return (
    <div className={css.sellerCard}>
      <NamedLink className={css.profileLink} name="SearchPage" to={{ search: brand?.search }}>
        <div className={css.sellerImg}>
          <img src={brand?.image} alt={brand?.name} />
        </div>
      </NamedLink>
    </div>
  );
}

export default FeaturedBrandCard;
